"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvinceListQuerySchema = exports.DistrictListQuerySchema = void 0;
const zod_1 = __importDefault(require("zod"));
const schemas_1 = require("../../../../schemas");
exports.DistrictListQuerySchema = zod_1.default.object({ provinceId: zod_1.default.string().optional() });
exports.ProvinceListQuerySchema = zod_1.default.object({ region: schemas_1.LocationRegionSchema.optional() });
